var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "membershipVip"
  }, [_c('m-head', {
    ref: "mHeadRef"
  }), _c('div', {
    staticClass: "membershipVip-main"
  }, [_c('div', {
    staticClass: "membership-vip"
  }, [_c('div', {
    staticClass: "membership-vip__level"
  }, [_vm._v(" VIP " + _vm._s(_vm.userInfo.vip_level) + " "), _c('div', {
    staticClass: "icon-quest"
  }, [_c('svg-icon', {
    attrs: {
      "name": "icon-quest"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return (() => _vm.popBenefitsShow = true).apply(null, arguments);
      }
    }
  })], 1)]), _c('div', {
    staticClass: "membership-vip-progress"
  }, [_c('div', {
    staticClass: "membership-vip-progress-bg",
    style: {
      '--w': '100%'
    }
  }, [_c('div', {
    staticClass: "bar"
  })]), _c('div', {
    staticClass: "membership-vip-progress-main",
    style: {
      '--w': _vm.userInfo.total_out_diamond / _vm.settingInfo.levelConfig.vipLevels[_vm.userInfo.vip_level == 0 ? 0 : _vm.userInfo.vip_level].exp * 100 + '%'
    }
  }, [_c('div', {
    staticClass: "bar"
  })])]), _c('div', {
    staticClass: "membership-vip__title"
  }, [_vm._v("You need to spend " + _vm._s(_vm.settingInfo.levelConfig.vipLevels[_vm.userInfo.vip_level == 0 ? 0 : _vm.userInfo.vip_level].exp - _vm.userInfo.total_out_diamond) + " diamonds to reach VIP " + _vm._s(_vm.userInfo.vip_level + 1))]), _vm._m(0)]), _c('div', {
    staticClass: "memebership-history",
    on: {
      "click": _vm.onPurchaseHistory
    }
  }, [_c('span', [_vm._v("Purchase History")])]), _c('div', {
    staticClass: "membership-list"
  }, _vm._l(_vm.cardInfoList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "membership-item",
      style: {
        background: `url(${require(`@images/${_vm.aiSkin}/shop-item-bg.png`)}) center/100% 100% no-repeat`
      }
    }, [_c('div', {
      staticClass: "membership-item-main"
    }, [_c('div', {
      staticClass: "membership-item__title"
    }, [_vm._v(_vm._s(item.name))]), _c('div', {
      staticClass: "membershop-lis"
    }, [_c('div', {
      staticClass: "membershop-itm"
    }, [_c('div', {
      staticClass: "membershop-itm-main",
      style: {
        background: `url(${require(`@images/${_vm.aiSkin}/shop-item-itm-bg.png`)}) center/100% 100% no-repeat`
      }
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.coin_addition)) + "%")]), _c('div', {
      staticClass: "membershop-itm__title"
    }, [_vm._v("FanPoints Boost")])]), _c('div', {
      staticClass: "membershop-itm"
    }, [_c('div', {
      staticClass: "membershop-itm-main day",
      style: {
        background: `url(${require(`@images/${_vm.aiSkin}/shop-item-itm-bg.png`)}) center/100% 100% no-repeat`
      }
    }, [_vm._v("+" + _vm._s(_vm.fmt_pre(item.spin_regen))), _c('span')]), _c('div', {
      staticClass: "membershop-itm__title"
    }, [_vm._v("Spins")])]), _c('div', {
      staticClass: "membershop-itm"
    }, [_c('div', {
      staticClass: "membershop-itm-main hour",
      style: {
        background: `url(${require(`@images/${_vm.aiSkin}/shop-item-itm-bg.png`)}) center/100% 100% no-repeat`
      }
    }, [_vm._v(_vm._s(_vm.fmt_pre(item.ai_chat))), _c('span', [_vm._v("/Day")])]), _c('div', {
      staticClass: "membershop-itm__title"
    }, [_vm._v("AI Chat")])])]), _c('div', {
      staticClass: "membershop-bottom"
    }, [_c('div', {
      staticClass: "membershop-limit"
    }, [_vm._v("Valid for " + _vm._s(item.day) + " days")]), _c('div', {
      staticClass: "btn-buy",
      on: {
        "click": function ($event) {
          return _vm.onCardBuy(item);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-diamond.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(item.diamond)) + " ")])])])]);
  }), 0)]), _c('m-menu'), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popBuyCardClass",
      "show": _vm.popBuyCardShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popBuyCardShow = $event;
      }
    }
  }, [_vm.selectCardItem ? _c('div', {
    staticClass: "pop-buyCard"
  }, [_c('div', {
    staticClass: "pop-buyCard-head",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/vip-detail-bg.jpg`)}) center/100% 100% no-repeat`
    }
  }, [_vm.selectCardItem ? _c('div', {
    staticClass: "pop-buyCard-head-main"
  }, [_c('div', {
    staticClass: "pop-buyCard__title"
  }, [_vm._v("Starter Pass")]), _c('div', {
    staticClass: "pop-buyCard__valid"
  }, [_vm._v("Valid for " + _vm._s(_vm.selectCardItem.day) + " days")]), _c('div', {
    staticClass: "pop-buyCard-list"
  }, [_c('div', {
    staticClass: "pop-buyCard-item"
  }, [_c('div', {
    staticClass: "pop-buyCard-item-main",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-itm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_vm._v("+" + _vm._s(_vm.fmt_pre(_vm.selectCardItem.coin_addition)) + "%")]), _c('div', {
    staticClass: "pop-buyCard-item__title"
  }, [_vm._v("FanPoints Boost")])]), _c('div', {
    staticClass: "pop-buyCard-item"
  }, [_c('div', {
    staticClass: "pop-buyCard-item-main day",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-itm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_vm._v("+" + _vm._s(_vm.fmt_pre(_vm.selectCardItem.spin_regen)))]), _c('div', {
    staticClass: "pop-buyCard-item__title"
  }, [_vm._v("Spins")])]), _c('div', {
    staticClass: "pop-buyCard-item"
  }, [_c('div', {
    staticClass: "pop-buyCard-item-main hour",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-itm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_vm._v(_vm._s(_vm.fmt_pre(_vm.selectCardItem.ai_chat))), _c('span', [_vm._v("/Day")])]), _c('div', {
    staticClass: "pop-buyCard-item__title"
  }, [_vm._v("AI Chat")])])])]) : _vm._e()]), _c('div', {
    staticClass: "pop-buyCard-info"
  }, [_c('div', {
    staticClass: "pop-buyCard-select"
  }, _vm._l([1, 5, 10], function (item, index) {
    return _c('div', {
      staticClass: "pop-buyCard-select-item",
      class: _vm.selectBuyCardAmount == item && 'active',
      on: {
        "click": () => {
          _vm.selectBuyCardAmount = item;
        }
      }
    }, [_c('div', {
      staticClass: "pop-buyCard-select-item__tag"
    }, [_vm._v(_vm._s(item == 1 ? "100" : item == 5 ? "90" : item == 10 ? "80" : "") + "% off")]), _c('div', {
      staticClass: "pop-buyCard-select-item__num"
    }, [_vm._v("x " + _vm._s(item))]), _c('div', {
      staticClass: "pop-buyCard-select-item__diamond"
    }, [_c('img', {
      attrs: {
        "src": require(`@images/${_vm.aiSkin}/icon-diamond.png`),
        "alt": ""
      }
    }), _vm._v(" " + _vm._s(_vm.fmt_pre(_vm.selectCardItem.diamond * item)))])]);
  }), 0), _c('div', {
    staticClass: "btn-task",
    on: {
      "click": function ($event) {
        return _vm.onBuyCard();
      }
    }
  }, [!_vm.isBuyLoading ? [_vm._v("Purchase and take offect")] : [_c('div', {
    staticClass: "circleLoading"
  })]], 2)])]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "isShadowClick": true,
      "className": "popBuyCardClass",
      "show": _vm.popBuyCardCreditsShow,
      "isBtnConfirm": false,
      "isBtnCancel": false,
      "content": "html"
    },
    on: {
      "update:show": function ($event) {
        _vm.popBuyCardCreditsShow = $event;
      }
    }
  }, [_vm.userCardInfo ? _c('div', {
    staticClass: "pop-buyCard"
  }, [_c('div', {
    staticClass: "pop-buyCard-head",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/vip-detail-bg.jpg`)}) center/100% 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "pop-buyCard-head-main"
  }, [_c('div', {
    staticClass: "pop-buyCard__title"
  }, [_vm._v("My Benefits")]), _c('div', {
    staticClass: "pop-buyCard-list benefits"
  }, [_c('div', {
    staticClass: "pop-buyCard-item"
  }, [_c('div', {
    staticClass: "pop-buyCard-item-main",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-bitm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_vm._v("+"), _c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.userCardInfo.total_coin_addition),
      "useUnit": true
    }
  }), _vm._v("%")], 1), _c('div', {
    staticClass: "pop-buyCard-item__title"
  }, [_vm._v("FanPoints Boost")])]), _c('div', {
    staticClass: "pop-buyCard-item"
  }, [_c('div', {
    staticClass: "pop-buyCard-item-main hour",
    style: {
      background: `url(${require(`@images/${_vm.aiSkin}/shop-item-bitm-bg.png`)}) center/100% 100% no-repeat`
    }
  }, [_c('m-count-up', {
    attrs: {
      "endVal": Number(_vm.userCardInfo.total_ai_chat),
      "useUnit": true
    }
  }), _c('span', [_vm._v("/Day")])], 1), _c('div', {
    staticClass: "pop-buyCard-item__title"
  }, [_vm._v("Ai Chat")])])])])]), _c('div', {
    staticClass: "pop-buyCard-history"
  }, [_c('div', {
    staticClass: "pop-buyCard-history__title"
  }, [_vm._v("My purchase history")]), _c('div', {
    ref: "scrollList",
    staticClass: "pop-buyCard-history-list"
  }, [_vm.myPurchaseHistory ? _vm._l(_vm.myPurchaseHistory, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "pop-buyCard-history-item"
    }, [_c('div', {
      staticClass: "pop-buyCard-history-item__title"
    }, [_vm._v(_vm._s(item.card_name))]), _c('div', {
      staticClass: "pop-buyCard-history-item__time"
    }, [_vm._v("Valid from " + _vm._s(_vm.fmt_time(item.created_at).format("YYYY-MM-DD HH:mm")) + " to " + _vm._s(_vm.fmt_time(item.expire_time).format("YYYY-MM-DD HH:mm")))])]);
  }) : _vm._e()], 2), _vm.loading ? _c('div', {
    staticClass: "loading-tip"
  }, [_vm._v("Loading more...")]) : _vm._e()])]) : _vm._e()]), _c('pop-prompt', {
    attrs: {
      "location": "center",
      "className": "popBenefits",
      "title": "Benefits",
      "isShadowClick": true,
      "content": "html",
      "show": _vm.popBenefitsShow,
      "isBtnCancel": false,
      "isBtnConfirm": false
    },
    on: {
      "update:show": function ($event) {
        _vm.popBenefitsShow = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pop-benefits"
  }, [_c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("Growth acceleration")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_vm._v("🎯 Mission FanPoints bonus🏃 Quickly reach level goals")])]), _c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("AI interaction privileges")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_vm._v("🤖 Voice AI cooldown time reduction")])]), _c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("Medal title")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_vm._v("🏅 Unlock subscription exclusive badges🎖 Enable exclusive titles (such as \"Star Messenger\")")])]), _c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("Airdrop reservation")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_vm._v("📬 Automatically enter the \"Future Airdrop Reservation List\"")])]), _c('div', {
    staticClass: "pop-benefits-item"
  }, [_c('div', {
    staticClass: "pop-benefits__title"
  }, [_vm._v("Exclusive missions")]), _c('div', {
    staticClass: "pop-benefits__label"
  }, [_c('p', [_vm._v("🔓 Unlock subscription exclusive mission lines")]), _c('p', [_vm._v("🎁 Get more growth points/badges/lottery tickets🎲 Weekly lottery (such as autographed photos, etc.)")])])]), _c('div', {
    staticClass: "pop-benefits-more"
  }, [_vm._v("More fan benefits in the future")])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "membership-vip__sub"
  }, [_vm._v(" The higher the VlP level, the more fan privileges you can"), _c('br'), _vm._v(" unlock in the future ")]);
}];
export { render, staticRenderFns };